import React from 'react'
import { useParams } from 'react-router-dom';
import UpdateUserPasswordForm from '../components/form/UpdateUserPasswordForm';
import HeaderLogo from "../components/shared/HeaderLogo";
import { Box } from "@mui/system";

const UpdateUserPasswordPage = () => {
    const urlParams = useParams();

    const updateUserPasswordPageStyle = {
        display: "flex",
        justifyContent: 'center',
        height: "100vh"
    };

    const updateUserPasswordContainerStyle = {
        justifySelf: "center",
        display: "grid",
        gridAutoRows: "1fr 2fr"
    }

    const headerLogoStyle = {
        maxHeight: "150px",
        minWidth: "350px",
        alignItems: "end"
    };

    return (
        <Box sx={updateUserPasswordPageStyle}>
            <div style={updateUserPasswordContainerStyle}>
                <HeaderLogo {...headerLogoStyle}/>
                <div style={{margin: "1em auto 0"}}>
                    <UpdateUserPasswordForm dataUrl={urlParams} submitButtonChildren={'confirmer le mot de passe'}/>
                </div>
            </div>
        </Box>
    )
}

export default UpdateUserPasswordPage;